import { BTOBillingTypeBuyKeysInversed } from '@teinor/erp/types/company/config/billingGroup/billingTypeBuy/billingTypeBuyOption'
import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router'
import { AdjustmentDeliveryNoteModelTypeExtended } from '../../../app/erp/screens/Logistic/ProductsParent/AdjustmentDN/types'
import { FormElement, FormRender } from '../../../forms/FormRenderer/types'
import { ImageInputFile } from '../../../forms/ImageInput/types'
import { OnSubmit } from '../../../forms/TwinForm/types'
import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

interface CreateAdjustmentProps {
    BillingGroupId?: number
    baseURL: string
}

export type SupplierAdjustmentInfoTy = {
    typeBilling: BTOBillingTypeBuyKeysInversed
    values: TwinDictionary
    SupplierId?: number
    CustomerId?: number
    projects: TwinDictionary | null
}

const useCreateAdjustment = ({ baseURL }: CreateAdjustmentProps) => {
    const [file, setFile] = useState<ImageInputFile[]>([])
    const { t } = useTwinTranslation()
    const itemsColumns = {
        'reference': { value: 'reference', name: t('reference', 'Referencia') },
        'code_bar': { value: 'code_bar', name: t('barCode', 'Código de barras') },
    }
    const navigate = useNavigate()

    const createAdjustment: OnSubmit = useCallback(async (res, values) => {
        const create = await res.json()
        return navigate(baseURL + '/' + create.id)
    }, [navigate, baseURL])

    const fileInfo: FormElement<any>[] = [
        {
            name: 'orderFilePath',
            component: 'FilesInput',
            label: t('uploadExcelOrCSV', 'Subir excel o CSV'),
            acceptFileConditions: {
                'text': ['.csv', '.xlsx']
            },
            onChange: setFile,
        },
    ]
    if (file.length) {
        fileInfo.push(
            {
                name: 'delimiter',
                label: t('delimiter', 'Delimitado'),
                component: 'InputWithLabelMargin',
                defaultValue: ';',
                required: true
            },
            {
                name: 'rowsToSkip',
                label: t('rowsToSkip', 'Filas que saltar'),
                component: 'InputWithLabelMarginIntegerStateFull',
                required: true
            },
            {
                name: 'searchByFile',
                label: t('searchBy', 'Buscar por'),
                component: 'CustomSelectWithSearchBar',
                items: itemsColumns,
                required: true
            },
            {
                name: 'posColumnSelected',
                label: t('posColumnSelected', 'Posición columna seleccionada'),
                component: 'InputWithLabelMarginIntegerStateFull',
                required: true
            },
            {
                name: 'posQuantityColumn',
                label: t('posQuantityColumn', 'Posición columna cantidad'),
                component: 'InputWithLabelMarginIntegerStateFull',
                required: true
            },
            {
                name: 'posPriceColumn',
                label: t('posPriceColumn', 'Posición columna precio'),
                component: 'InputWithLabelMarginIntegerStateFull',
            },
            {
                name: 'posNotesColumn',
                label: t('posNotesColumn', 'Posición columna notas'),
                component: 'InputWithLabelMarginIntegerStateFull',
            },
        )
    }
    const addressFields: FormRender<AdjustmentDeliveryNoteModelTypeExtended> = []
    const mySupplierInfo: FormElement<keyof AdjustmentDeliveryNoteModelTypeExtended>[] = []

    return { createAdjustment, fileInfo, addressFields, mySupplierInfo }
}

export default useCreateAdjustment
